module.exports = __webpack_public_path__ + "static/media/raspap_01.2acae854.png";